import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import VueLazyload from "vue-lazyload";
import infiniteScroll from "vue-infinite-scroll";
import i18n from "./i18n";
import VueScrollTo from "vue-scrollto";
import VueObserveVisibility from "vue-observe-visibility";
import axios from "axios";

// Configure axios for session-based authentication
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "application/json";

// Add CSRF token to all axios requests
axios.interceptors.request.use(config => {
  if (window.csrf) {
    config.headers["X-CSRF"] = window.csrf;
  }
  return config;
});

Vue.use(VueObserveVisibility);
Vue.use(VueScrollTo);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueLazyload);
Vue.use(infiniteScroll);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
